import {Entity} from 'app/core/main.entity';
import {Type} from 'class-transformer';
import {File} from 'app/entities/file.entity';

export class WorkerShort extends Entity {
  id: number;
  name: string;

  @Type(() => File)
  photo?: File = null;

  getPhoto?(): string {
    return this.photo?.fileUrl();
  }

  getTitle?() {
    return this.name;
  }
}
